import React, { useState, useEffect, useContext, forwardRef, useImperativeHandle } from "react";
import { Loader } from "../../loader/Loader";
import { fetchUIConfigData, getMetaData } from "../../../services/uiConfigService";
import { KPI_REVIEW_CONFIG_NAME } from "../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKPIReviewRegistry";
import { openPopup } from "../../../stateManagement/actions/popupActions";
import "../../../features/salescodeStudio/mandatoryConfigs/mandatoryConfigCommon.css";
import ReloadButton from "../../../features/salescodeStudio/mandatoryConfigs/uiThemeConfig/widgets/reloadButton";
// import {DeepClone} from '@mui'
import {
  getDefaultConfigArray,
  isKPIConfigAllowed,
  getAllAllowedKPIsID,
  saveKPIReviewData,
  prepareDataForSaving,
  formatDataWithoutFasleShow,
  checkForDataFieldValidation
} from "../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";

import { Button } from "@mui/material";
// custom component imports
import KPIFilter from "./kpiFilter/KPIFilter";
import KPIConfigAndPreview from "./kpiConfigAndPreview/KPIConfigAndPreview";

import "./manageKPIReviewConfig.css";
import { PlaygroundConfigValueContext } from "../../newPortal/NewPortalLayout";
import { InputFieldLengthValidationType } from "../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKPIType";
import { defaultConfig } from "antd/es/theme/context";
type Props = {
  inputLengthValidation: InputFieldLengthValidationType;
  triggerReset: number;
  handleReset:()=>void;
}
const ManageKPIReviewConfig= forwardRef<any,Props>(({ inputLengthValidation, triggerReset ,handleReset},ref) => {
  const [areInputFieldsValid, setAreInputFieldsValid] = useState<boolean>(true);
  const [userConfig, setUserConfig] = useState<Array<Record<string, any>>>([]);
  const [selectedKPIsKeys, setSelectedKPIsKeys] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [hasActiveChild, setHasActiveChild] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [defaultConfigGlobal, setDefaultConfigGlobal] = useState<any>(
    {}
  );
  const [values, setValues] = useState<any>(
    {}
  );
  const PlayroundConfigContext = useContext(PlaygroundConfigValueContext);
  const {
    playgroundConfiguration,
    setPlayGroundConfiguration,
    onTriggerConfigChanges,
    keyValue,
    setKeyValue,
    cleanSyncDataLoaderIds,
    setCleanSyncDataLoaderIds,
  } = PlayroundConfigContext ?? {
    playgroundConfiguration: [],
    setPlayGroundConfiguration: () => { },
    onTriggerConfigChanges: () => { },
    setKeyValue: () => { },
    keyValue: 0,
    cleanSyncDataLoaderIds: [],
    setCleanSyncDataLoaderIds: () => { },
  };


  useEffect(() => {
    // Check if `activeChild` exists in localStorage when the component mounts
    // console.log("initial fetch ui config called")
    fetchUIConfigData(setValues, setDefaultConfigGlobal, KPI_REVIEW_CONFIG_NAME,setLoading)
    setHasActiveChild(!!localStorage.getItem("activeChild"));
  }, []);
  const handleSave = async () => {
    if (!areInputFieldsValid)
      return;
    //saving this config <|>
    const configToSave: Record<string, any>[] = prepareDataForSaving(
      userConfig,
      selectedKPIsKeys,
      defaultConfigGlobal
    );

    const ans = formatDataWithoutFasleShow(configToSave);
    //TODO: apply the new flow code here ...
    // console.log("saved this -> ",ans);
    try {
      await saveKPIReviewData(ans);
    } catch (error) {
      console.error(error);
      openPopup("Error", "Some error occured while saving data");
    }
  };

  const getData = async () => {
    // console.log("get data called ")
    setLoading(true);

    // Utility function to extract values by name
    const getValueArrayByName = (
      data: Array<Record<string, any>>,
      targetName: string
    ): Array<Record<string, any>> => {
      const foundObject = data.find((item) => item.name === targetName);
      return foundObject ? foundObject.value : [];
    };

    try {
      // Fetch user-selected metadata
      const data = await getMetaData("clientConfig", KPI_REVIEW_CONFIG_NAME);
      // Extract saved configuration
      const savedConfig = getValueArrayByName(data, "kpiConfigList");
      // console.log("recived this -> ", savedConfig);
      // Prepare default configuration
      const defaultConfig: Record<string, any>[] = getDefaultConfigArray(defaultConfigGlobal);
      // Extract selected keys before merging the savedconfig with default info
      const selectedKeys: string[] = savedConfig.map((element) => element.id);
      /* if element.id belong to selectedkeys then use savedConfig data , else use defaultConfig data  */
      const userConfigTemp = defaultConfig.reduce(
        (acc: Record<string, any>[], kpi: Record<string, any>) => {
          const element =
            (selectedKeys.includes(kpi.id)
              ? savedConfig.find((_kpi) => _kpi.id == kpi.id)
              : kpi) || kpi;
          const curKpi: Record<string, any> = {
            id: element.id,
            title: element.title,
          };
          const istakingDataFromSaved = savedConfig.some(
            (_kpi) => _kpi.id == kpi.id
          );
          // Conditionally add data_points and buttons if it exists
          if (
            element.detail_summary?.find(
              (item: Record<string, any>) => item.id === "toggleListView"
            )
          ) {
            curKpi.buttons = element.detail_summary?.find(
              (item: Record<string, any>) => item.id === "toggleListView"
            )?.toggle_list;
          }
          if (element.data_points) {
            //if taking datapoint from the saved config then take all , else take the first 3
            const allDataPoints = element?.data_points || [];
            curKpi.data_points = istakingDataFromSaved
              ? element?.data_points
              : element?.data_points?.splice(
                0,
                Math.min(3, allDataPoints.length)
              );
          }

          acc.push(curKpi);

          return acc;
        },
        []
      );
      setUserConfig(userConfigTemp);
      /*
       * if the user enters at the page for the first time , i.e the recived config will be empty , so we will add all the kpis to the selected keys
       */
      if (selectedKeys.length === 0) {
        setSelectedKPIsKeys(getAllAllowedKPIsID(defaultConfigGlobal));
      } else {
        setSelectedKPIsKeys(selectedKeys);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const updateUserConfig = (_id: string, _kpi: Record<string, any>) => {
    const newUserConfig = userConfig.map((kpi) =>
      kpi.id === _id ? _kpi : kpi
    );
    setUserConfig(newUserConfig);
  };

  async function handlePlaygroudnChanges() {

    const configToSave: Record<string, any>[] = prepareDataForSaving(
      userConfig,
      selectedKPIsKeys,
      defaultConfigGlobal
    );
    const ans = formatDataWithoutFasleShow(configToSave);

    const configVal = [{
      name: "kpiConfigList",
      type: "list",
      value: ans,
      docUrl: "",
      description: "list of KPIs to be displayed in the app",
      defaultValue: [],
      possibleVals: ["Map[]"],
    }];


    const convertedVal: any = configVal.map((obj) => ({
      ...obj,
      isValueUpdated: true,
      domainType: "salesrep_kpi_configuration",
    }))
    setCleanSyncDataLoaderIds([]);
    setPlayGroundConfiguration(convertedVal);
  }

  useEffect(() => {
    // console.log("get data called ")
    if (Object.keys(defaultConfigGlobal).length !== 0)
      getData();
  }, [triggerReset, defaultConfigGlobal])

  useEffect(() => {
    setAreInputFieldsValid(checkForDataFieldValidation(userConfig, selectedKPIsKeys, inputLengthValidation))

    handlePlaygroudnChanges()

  }, [userConfig, selectedKPIsKeys]);

  const handlePreview=async()=>{
     try {
              setIsSpinning(true);

              const res: any = await onTriggerConfigChanges(); // Wait for the API call to complete
              //  alert(res)
              // console.log("res is " + res);
              if (res["status"] === 200 || res["status"] === 200) {
                setKeyValue(keyValue + 1);
              }
            } catch (error) {
              console.error("Error in onTriggerConfigChanges:", error);
            }
            setTimeout(() => {
              setIsSpinning(false);
            }, 1000);
  }

  useImperativeHandle(ref,()=>(
    {
      handlePreview,
      validationFailiure:!areInputFieldsValid
    }
  ))


  return (
    <div className="config-main-logic-container">
      <div className="config-main">
        {loading || Object.keys(defaultConfigGlobal).length === 0 ? (
          <Loader />
        ) : (
          <>
            <KPIFilter
              defaultConfigGlobal={defaultConfigGlobal}
              userConfig={userConfig}
              selectedKPIsKeys={selectedKPIsKeys}
              setSelectedKPIsKeys={setSelectedKPIsKeys}
            />
            {selectedKPIsKeys.length > 0 && (
              <KPIConfigAndPreview
                selectedKPIsKeys={selectedKPIsKeys}
                setSelectedKPIsKeys={setSelectedKPIsKeys}
                userConfig={userConfig}
                updateUserConfig={updateUserConfig}
                inputLengthValidation={inputLengthValidation}
                defaultConfigGlobal={defaultConfigGlobal}
              />
            )}
          </>
        )}
      </div>
      <div
        className={`config-save-button-container ${!areInputFieldsValid ? "custom-cursor-not-allowed" : ""
          }  ${hasActiveChild ? 'has-active-child' : ''}`}
      >
         <Button
        disabled={!areInputFieldsValid}
       
        onClick={handleReset}
        sx={{
          alignSelf: "flex-end",
          fontSize: "13px",
          color:"grey",
          padding:"6px 24px",
          border:"0.5px solid grey",
          marginRight:"10px",
          textTransform:"none",
          borderRadius:"8px",
        }}
      >
        Reset
       
      </Button>
      <Button
        disabled={!areInputFieldsValid}
       
        onClick={handleSave}
        sx={{
          alignSelf: "flex-end",
          borderRadius:"8px",
          padding:"6px 24px",
          fontSize: "13px",
          border:"0.5px solid #00C6B1",
           backgroundColor: "#00C6B1",
          color:"#ffffff",
           "&:hover": {
      backgroundColor: "#00C6B1", 
    },
    "&:active": {
      backgroundColor: "#00C6B1",
    },
          textTransform:"none"
        }}
      >
        Save
      </Button>
        {/* <Button
          disabled={!areInputFieldsValid}
          variant="contained" */}
           {/* color= "#00C6B1"

          onClick={async () => {
            try {
              setIsSpinning(true);

              const res: any = await onTriggerConfigChanges(); // Wait for the API call to complete
              //  alert(res)
              // console.log("res is " + res);
              if (res["status"] === 200 || res["status"] === 200) {
                setKeyValue(keyValue + 1);
              }
            } catch (error) {
              console.error("Error in onTriggerConfigChanges:", error);
            }
            setTimeout(() => {
              setIsSpinning(false);
            }, 1000);
          }}
          sx={{
            alignSelf: "flex-end",
            marginY: "1rem",
            fontSize: "clamp(0.5rem,0.9vw + 0.065rem, 1.6rem)",
            backgroundColor: "#00C6B1",
            marginRight: "10px",
          }} */}
        {/* > */}
          {/* PREVIEW */}
          {/* <div sx={{color:""}}> */}
          {/* <ReloadButton
            isSpinning={isSpinning}
            setIsSpinning={setIsSpinning} */}
            {/* // handleClick={async () =>{ */}
            {/* //   await onTriggerConfigChanges();
            //   setRefreshCount((prev) => prev + 1);
            // }}
            handleClick={async () => {
              try {
                setIsSpinning(true);
                setCleanSyncDataLoaderIds([]);
                const res: any = await onTriggerConfigChanges(); // Wait for the API call to complete */}
                {/* //  alert(res)
                // console.log("res is " + res);
                if (res["status"] === 200 || res["status"] === 200) {
                  setKeyValue(keyValue + 1);
                }
              } catch (error) {
                console.error("Error in onTriggerConfigChanges:", error);
              }
              setTimeout(() => {
                setIsSpinning(false);
              }, 1000);
            }} */}
          {/* /> */}
          {/* </div> */}
          {/* </div> */}
        {/* </Button>
        <Button
          disabled={!areInputFieldsValid}

          variant="contained"
          onClick={handleSave}
          sx={{
            alignSelf: "flex-end",
            marginY: "1rem",
            fontSize: "clamp(0.5rem,0.9vw + 0.065rem, 1.6rem)",
            gap: "7px"
          }}
        >
          SAVE
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg>
        </Button> */}
      </div>
    </div>
  );
})
export default ManageKPIReviewConfig;
